import { OnboardingTooltipActionTypes, OnboardingTooltipState, SET_VISIBLE_TOOLTIPS } from "./types";

const initialOnboardingTooltipState: OnboardingTooltipState = {
  visibleTooltips: new Map()
};

export const onboardingTooltipReducer = (
  state: OnboardingTooltipState = initialOnboardingTooltipState,
  action: OnboardingTooltipActionTypes
): OnboardingTooltipState => {
  switch (action.type) {
    case SET_VISIBLE_TOOLTIPS:
      return {
        ...state,
        visibleTooltips: action.meta.params.visibleTooltips
      };
    default:
      return state;
  }
};
